import { render } from "./TheFavoritesWidget.vue?vue&type=template&id=51240908"
import script from "./TheFavoritesWidget.vue?vue&type=script&lang=js"
export * from "./TheFavoritesWidget.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__